import {useState, type FormEvent} from 'react';
import {AwButton, AwField} from '@ascension-tracker/ascension-ui';
import {useCreateTag, useDeleteTag, useProjectTags} from '../hooks/useTasks.js';

export function TagManager({projectId}: {projectId: string}) {
  const tags = useProjectTags(projectId);
  const createTag = useCreateTag(projectId);
  const deleteTag = useDeleteTag(projectId);
  const [name, setName] = useState('');

  async function create(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!name.trim()) return;
    await createTag.mutateAsync({name: name.trim()});
    setName('');
  }

  return (
    <div className="tag-manager">
      {(tags.data ?? []).map(tag => (
        <span key={tag.id} className="tag-chip" style={tag.color ? {borderColor: tag.color, color: tag.color} : undefined}>
          {tag.name}
          <button type="button" aria-label={`Delete tag ${tag.name}`} onClick={() => deleteTag.mutate(tag.id)}>×</button>
        </span>
      ))}
      <form className="task-quick-add" onSubmit={create}>
        <AwField id="settings-new-tag" label="" placeholder="New tag name…" value={name} onChange={event => setName(event.target.value)}/>
        <AwButton type="submit" variant="secondary" disabled={!name.trim()}>Add tag</AwButton>
      </form>
    </div>
  );
}
